import { GET_DMX_DEVICE_BY_ID, GET_DMX_DEVICE_BY_ID_SUCCESS, GET_DMX_DEVICE_BY_ID_ERROR } from './actionTypes';

const initialState = {
  errorGetDmxDeviceById: '',
  loadingGetDmxDeviceById: false,
  device: null,
};

const getDeviceById = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_DEVICE_BY_ID:
      state = { ...state, loadingGetDmxDeviceById: true };
      break;
    case GET_DMX_DEVICE_BY_ID_SUCCESS:
      state = { ...state, loadingGetDmxDeviceById: false, device: action.payload.device };
      break;
    case GET_DMX_DEVICE_BY_ID_ERROR:
      state = { ...state, errorGetDmxDeviceById: action.payload, loadingGetDmxDeviceById: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDeviceById;
